
import React, { DragEvent } from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

interface EmptyStateProps {
  onFileSelect: () => void;
  dropZoneRef: React.RefObject<HTMLDivElement>;
  isDragging: boolean;
  handleDragEnter: (e: DragEvent<HTMLDivElement>) => void;
  handleDragOver: (e: DragEvent<HTMLDivElement>) => void;
  handleDragLeave: (e: DragEvent<HTMLDivElement>) => void;
  handleDrop: (e: DragEvent<HTMLDivElement>) => void;
}

const EmptyState = ({
  onFileSelect,
  dropZoneRef,
  isDragging,
  handleDragEnter,
  handleDragOver,
  handleDragLeave,
  handleDrop
}: EmptyStateProps) => {
  return (
    <div 
      ref={dropZoneRef} 
      className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors h-[400px] flex flex-col items-center justify-center ${isDragging ? 'border-blue-500 bg-slate-700/50' : 'border-slate-600 hover:border-blue-400 hover:bg-slate-700/30'}`} 
      onClick={onFileSelect} 
      onDragEnter={handleDragEnter} 
      onDragOver={handleDragOver} 
      onDragLeave={handleDragLeave} 
      onDrop={handleDrop}
    >
      <Download className="h-16 w-16 mx-auto mb-5 text-slate-400" />
      <p className="text-xl text-slate-300 font-medium mb-2">
        No data available
      </p>
      <p className="text-slate-400 text-lg mb-4">
        Click to browse or drag and drop an Excel file to import data
      </p>
      <Button variant="outline" size="lg" onClick={onFileSelect} className="bg-slate-800 hover:bg-slate-700 text-white border-slate-700 mt-2">
        <Download className="h-4 w-4 mr-2" />
        Import Excel Data
      </Button>
    </div>
  );
};

export default EmptyState;
